import React from 'react';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { ParkingReservationSummaryDto } from 'Services/Api/_HumanWritten/ParkingService';
import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

interface ParkingReservationSummaryCardProps {
	reservation: ParkingReservationSummaryDto;
	hideLinks?: boolean;
	showReservationId?: boolean;
}

function formatDuration(startDate: string, endDate: string): string {
	const days = Math.max(
		1,
		Math.ceil((new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24)),
	);
	return `${days} day${days !== 1 ? 's' : ''}`;
}

export function ParkingReservationSummaryCard({
	reservation,
	hideLinks,
	showReservationId,
}: ParkingReservationSummaryCardProps) {
	return (
		<div className="booking-summary-card__inner parking-reservation-summary-card">
			<div className="booking-summary-card__header show-price">
				<p className="booking-summary-card__type-and-number">
					Parking Reservation{showReservationId && reservation.humanReadableId ? ' ' : ''}
					{showReservationId &&
						reservation.humanReadableId &&
						(hideLinks ? (
							<span>#{reservation.humanReadableId}</span>
						) : (
							<Link to={`/parking-reservations/${reservation.id}`}>#{reservation.humanReadableId}</Link>
						))}
				</p>
				<p className="line-item-price">{formatPriceDisplay(reservation.totalPrice, false)}</p>
			</div>
			<div className="parking-reservation-summary-card__body">
				{reservation.locationName && (
					<div className="parking-reservation-summary-card__location">
						<Icon
							name="distance"
							classname="parking-reservation-summary-card__location-icon"
							useMaterialIcons
						/>
						<span>{reservation.locationName}</span>
					</div>
				)}
				<div className="parking-reservation-summary-card__vehicles">
					{reservation.vehicles.map(vehicle => {
						const vehicleIcon = vehicle.parkingVehicleTypeIconName || 'directions_car';
						return (
							<div key={vehicle.id} className="parking-reservation-summary-card__vehicle">
								<div className="parking-reservation-summary-card__vehicle-info">
									<Icon
										name={vehicleIcon}
										classname="parking-reservation-summary-card__vehicle-icon"
										useMaterialIcons
									/>
									<div className="parking-reservation-summary-card__vehicle-details">
										<span className="parking-reservation-summary-card__vehicle-type">
											{vehicle.parkingVehicleTypeName || 'Vehicle'}
										</span>
										{vehicle.registration && (
											<span className="parking-reservation-summary-card__vehicle-rego">
												{vehicle.registration.toUpperCase()}
											</span>
										)}
									</div>
								</div>
								<div className="parking-reservation-summary-card__vehicle-dates">
									<span>{dayjs(vehicle.startDate).format('D MMM')}</span>
									<Icon
										name="arrow_forward"
										classname="parking-reservation-summary-card__arrow"
										useMaterialIcons
									/>
									<span>{dayjs(vehicle.endDate).format('D MMM')}</span>
									<span className="parking-reservation-summary-card__vehicle-duration">
										({formatDuration(vehicle.startDate, vehicle.endDate)})
									</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
}
